import { Col, Row } from 'antd';
import { useState } from 'react';
import { Field as FieldRFF } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { AiFillCloseCircle } from 'react-icons/ai';

import { DocumentModel } from 'api/documents/documents.model';
import Button from 'components/Buttons';
import Input from 'components/Form/Input';
import Modal from 'components/Modal';
import SectionTitle from 'components/SectionTitle';
import { CertificateDetailsModel } from 'models/certificate.model';
import CertificatesPage from 'pages/CertificatesPage';

import * as Styled from './ComponentInformation.styles';
import { componentConfig } from './componentConfig';

type Props = {
  componentIndex: number;
  onLinkCertificate: (certificate: DocumentModel<CertificateDetailsModel>) => void;
  onDelete: () => void;
};

const ComponentInformation = ({ componentIndex, onLinkCertificate, onDelete }: Props) => {
  const [selectedCertificate, setSelectedCertificate] =
    useState<DocumentModel<CertificateDetailsModel>>();
  const [linkedComponentIndexes, setLinkedComponentIndexes] = useState<number[]>([]);
  const { t } = useTranslation();
  const [isModalVisible, setModalVisible] = useState(false);

  const rowSelection = {
    onChange: (_: React.Key[], selectedRows: DocumentModel<CertificateDetailsModel>[]) => {
      setSelectedCertificate(selectedRows[0]);
    },
  };
  const handleOk = () => {
    if (selectedCertificate) {
      onLinkCertificate(selectedCertificate);
      setLinkedComponentIndexes([...linkedComponentIndexes, componentIndex]);
    }

    setModalVisible(false);
  };

  const isComponentLinked = () =>
    linkedComponentIndexes.findIndex(
      (linkedComponentIndex) => linkedComponentIndex === componentIndex
    ) > -1;

  const handleCancel = () => setModalVisible(false);
  return (
    <>
      <SectionTitle>
        <Row justify="space-between">
          <Styled.Title>{t('certificate.componentInformation')}</Styled.Title>
          <Styled.RemoveButton
            type="text"
            $customIcon
            $reverse
            icon={<AiFillCloseCircle />}
            onClick={() => onDelete()}
          >
            {t('certificate.removeComponent')}
          </Styled.RemoveButton>
        </Row>
      </SectionTitle>
      <Row style={{ marginBottom: '40px' }}>
        <Button type="link" onClick={() => setModalVisible(true)}>
          {t(`certificate.linkWithExisting`)}
        </Button>
      </Row>
      {selectedCertificate && (
        <Row gutter={60} align="bottom" style={{ alignItems: 'flex-start' }}>
          {componentConfig.map(({ id, required, notDisableWhenLinked }) => (
            <Col md={24} lg={12} key={`components[${componentIndex}]${id}`}>
              <FieldRFF
                name={`components[${componentIndex}].${id}`}
                label={t(`certificate.component.${id}.label`)}
                tip={t(`certificate.component.${id}.tip`)}
                placeholder={t(`certificate.component.${id}.placeholder`)}
                data-cy={`components[${componentIndex}].${id}`}
                required={required}
                disabled={!notDisableWhenLinked && isComponentLinked()}
                component={Input}
              />
            </Col>
          ))}
        </Row>
      )}

      <Modal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <SectionTitle>{t('certificate.addCertificate')}</SectionTitle>
        <CertificatesPage rowSelection={{ type: 'radio', ...rowSelection }} />
      </Modal>
    </>
  );
};

export default ComponentInformation;
